import { render, staticRenderFns } from "./PermissionSimplePage.vue?vue&type=template&id=673ebe30&"
import script from "./PermissionSimplePage.vue?vue&type=script&lang=js&"
export * from "./PermissionSimplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673ebe30')) {
      api.createRecord('673ebe30', component.options)
    } else {
      api.reload('673ebe30', component.options)
    }
    module.hot.accept("./PermissionSimplePage.vue?vue&type=template&id=673ebe30&", function () {
      api.rerender('673ebe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Page/PermissionSimplePage.vue"
export default component.exports